import type {EmptyPayload} from 'constants/events/EventPayloadUtils';

export const ORDER_EVENT_PAYLOADS = {
  ORDER_FOLDER_TOGGLE_COLLAPSED: {} as EmptyPayload,

  ORDER_SEARCH: {} as EmptyPayload,
  ORDER_SEARCH_COMPLETED: {} as EmptyPayload,
  ORDER_SEARCH_FAILED: {} as EmptyPayload,

  ORDER_OPEN: {} as EmptyPayload,
  ORDER_OPEN_COMPLETED: {} as EmptyPayload,
  ORDER_OPEN_FAILED: {} as EmptyPayload,

  ORDER_UPDATE: {} as EmptyPayload,
  ORDER_UPDATE_COMPLETED: {} as EmptyPayload,
  ORDER_UPDATE_FAILED: {} as EmptyPayload,

  ORDER_DELETE: {} as EmptyPayload,
  ORDER_DELETE_COMPLETED: {} as EmptyPayload,
  ORDER_DELETE_FAILED: {} as EmptyPayload,
} as const;

export type OrderEventPayload = typeof ORDER_EVENT_PAYLOADS;
